import React, { ReactNode } from 'react';
import BaseComponent from '../../base/base-component';
import SvgIcon from '../svg-icon/svg-icon';
import { SvgIconPathCommand } from '../svg-icon/svg-icon-enum';
import { IGravityForm, IGravityFormFields } from './gravity-forms-interface';
const axios = require('axios');
const { nanoid } = require('nanoid');
const oauthSignature = require('oauth-signature');

export default class GravityForm extends BaseComponent<IGravityForm> {
  public constructor(props: IGravityForm) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.validationForm = this.validationForm.bind(this);
    this.state = Object.fromEntries(
      props.form.formFields.map((field) => [`input_${field.id}`, ''])
    );
    this.state['confirmationMessage'] = '';
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  validationForm() {
    for (const field of this.props.form.formFields) {
      if (field.isRequired && this.state['input_' + field.id] == '') {
        this.setState({
          ['input_' +
          field.id +
          '_error']: `Please enter a valid ${field.label}`,
        });
        return false;
      } else {
        this.setState({
          ['input_' + field.id + '_error']: '',
        });
      }
    }
    return true;
  }

  async submitForm(e) {
    const apiUrl = this.props.form.apiURL + '/submissions';
    e.preventDefault();
    if (this.validationForm()) {
      try {
        var result = await axios({
          method: 'post',
          url: apiUrl,
          data: this.state,
        });
      } catch (err) {
        return {
          statusCode: 400,
          body: JSON.stringify({
            error: err,
          }),
        };
      }

      this.setState({
        confirmationMessage: result.data.confirmation_message,
      });
    }
  }

  public render(): ReactNode {
    const { form, formClassName } = this.props;
    const confirmationMessage = this.state['confirmationMessage'];
    return confirmationMessage ? (
      <div
        dangerouslySetInnerHTML={{
          __html: confirmationMessage,
        }}
      />
    ) : (
      <form onSubmit={(e) => this.submitForm(e)} className={formClassName}>
        <div className="gform_fields">
          {form.formFields.map((formField: IGravityFormFields) => {
            let input;
            switch (formField.type) {
              case 'textarea':
                input = (
                  <textarea
                    name={'input_' + formField.id}
                    id={'input_' + formField.id}
                    placeholder={formField.placeholder}
                    onChange={(e) => this.handleChange(e)}
                  />
                );
                break;

              default:
                input = (
                  <input
                    type={formField.type}
                    name={'input_' + formField.id}
                    id={'input_' + formField.id}
                    placeholder={formField.placeholder}
                    onChange={(e) => this.handleChange(e)}
                  />
                );
                break;
            }
            return (
              <div
                key={formField.id}
                className={`c-form-fields ${formField.cssClass}`}
              >
                <label
                  className="visually-hidden"
                  htmlFor={'input_' + formField.id}
                >
                  {formField.label}
                </label>
                {input}
                <div className="c-form-err">
                  {this.state['input_' + formField.id + '_error']}
                </div>
              </div>
            );
          })}
        </div>
        <button className="c-btn is-purple is-large">
          {form.button.text}
          <SvgIcon
            width="18"
            viewBox="0 0 18 12"
            paths={[
              {
                command: SvgIconPathCommand.M11_ARROW_RIGHT,
                fill: '#0D0C0D',
              },
            ]}
          />
        </button>
      </form>
    );
  }
}
